<template>
  <div>
    <div class="node-wrap" v-if="nodeConfig.nodeType < 4">
      <div
        class="node-wrap-box"
        :class="
          (nodeConfig.nodeType == 0 ? 'start-node ' : '') +
            (isTried && nodeConfig.error ? 'active error' : '')
        "
      >
        <div>
          <!-- title  start -->
          <div class="title" :style="`background: rgb(${bgColor});`">
            <span v-if="nodeConfig.nodeType == 0">{{
              nodeConfig.nodeName
            }}</span>
            <template v-else>
              <span class="iconfont">
                {{
                  nodeConfig.nodeType == 1 || nodeConfig.nodeType == 3
                    ? ''
                    : ''
                }}
              </span>
              <input
                type="text"
                v-if="isInput"
                class="ant-input editable-title-input"
                @blur="blurEvent()"
                @focus="$event.currentTarget.select()"
                v-focus
                v-model="nodeConfig.nodeName"
                :placeholder="defaultText"
              />
              <span v-else class="editable-title" @click="clickEvent()">
                {{ nodeConfig.nodeName }}
              </span>
              <i class="anticon anticon-close close" @click="delNode"></i>
            </template>
          </div>
          <!-- title end -->
          <!-- content start -->
          <div class="content" @click="setPerson">
            <div class="text">
              <span class="placeholder" v-if="!showText">
                请选择{{ defaultText }}
              </span>
              {{ showText }}
            </div>
            <i class="anticon anticon-right arrow"></i>
          </div>
          <!-- content end -->
          <div class="error_tip" v-if="isTried && nodeConfig.error">
            <i class="anticon anticon-exclamation-circle"></i>
          </div>
        </div>
      </div>
      <addNode :childNodeP.sync="nodeConfig.child"></addNode>
    </div>
    <div class="branch-wrap" v-if="nodeConfig.nodeType == 5">
      <div class="branch-box-wrap">
        <div class="branch-box">
          <button class="add-branch" @click="addTerm">添加条件</button>
          <div
            class="col-box"
            v-for="(item, index) in nodeConfig.branchList"
            :key="index"
          >
            <div class="condition-node">
              <div class="condition-node-box">
                <div
                  class="auto-judge"
                  :class="isTried && item.error ? 'error active' : ''"
                >
                  <div
                    class="sort-left"
                    :nihao="index"
                    :datasss="nodeConfig.branchList.length - 1"
                    v-if="
                      index != 0
                        ? index != nodeConfig.branchList.length - 1
                        : false
                    "
                    @click="arrTransfer(index, -1)"
                  >
                    &lt;
                  </div>
                  <div class="title-wrapper">
                    <input
                      v-if="isInputList[index]"
                      type="text"
                      class="ant-input editable-title-input"
                      @blur="blurEvent(index)"
                      @focus="$event.currentTarget.select()"
                      v-focus
                      v-model="item.nodeName"
                    />
                    <span
                      v-else
                      class="editable-title"
                      @click="clickEvent(index)"
                    >
                      {{ item.nodeName }}
                    </span>
                    <span
                      class="priority-title"
                      @click="setPerson(item.priorityLevel)"
                    >
                      优先级{{ item.priorityLevel }}
                    </span>
                    <span
                      v-if="index != nodeConfig.branchList.length - 1"
                      class="priority-copy"
                      @click="setCopyCondition(item)"
                    >
                      复制
                    </span>
                    <i
                      class="anticon anticon-close close"
                      @click="delTerm(index)"
                      v-if="index != nodeConfig.branchList.length - 1"
                    ></i>
                  </div>
                  <div
                    class="sort-right"
                    v-if="
                      index != nodeConfig.branchList.length - 1
                        ? index != nodeConfig.branchList.length - 2
                        : false
                    "
                    @click="arrTransfer(index)"
                  >
                    &gt;
                  </div>
                  <div class="content" @click="setPerson(item.priorityLevel)">
                    {{ preload.conditionStr(nodeConfig, index) }}
                  </div>
                  <div class="error_tip" v-if="isTried && item.error">
                    <i class="anticon anticon-exclamation-circle"></i>
                  </div>
                </div>
                <addNode :childNodeP.sync="item.child"></addNode>
              </div>
            </div>
            <nodeWrap
              v-if="item.child"
              :nodeConfig.sync="item.child"
            ></nodeWrap>
            <template v-if="index == 0">
              <div class="top-left-cover-line"></div>
              <div class="bottom-left-cover-line"></div>
            </template>
            <template v-if="index == nodeConfig.branchList.length - 1">
              <div class="top-right-cover-line"></div>
              <div class="bottom-right-cover-line"></div>
            </template>
          </div>
        </div>
        <addNode :childNodeP.sync="nodeConfig.child"></addNode>
      </div>
    </div>
    <nodeWrap
      v-if="nodeConfig.child"
      :nodeConfig.sync="nodeConfig.child"
    ></nodeWrap>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import _ from 'lodash';
import addNode from './addNode.vue';
import preload from '../plugins/preload';
export default {
  name: 'nodeWrap',
  props: ['nodeConfig'],
  components: { addNode },
  data() {
    return {
      preload,
      placeholderList: ['发起人', '审核人', '抄送人', '办理人'],
      isInputList: [],
      isInput: false
    };
  },
  mounted() {
    if (this.nodeConfig.nodeType == 1) {
      this.nodeConfig.error = !preload.setApproverStr(this.nodeConfig);
    } else if (this.nodeConfig.nodeType == 2) {
      this.nodeConfig.error = !preload.copyerStr(this.nodeConfig);
    } else if (this.nodeConfig.nodeType == 4) {
      this.resetConditionNodesErr();
    }
  },
  computed: {
    ...mapState('workflow', [
      'isTried',
      'promoterConfig1',
      'approverConfig1',
      'copyerConfig1',
      'conditionsConfig1',
      'transactorConfig1'
    ]),
    defaultText() {
      return this.placeholderList[this.nodeConfig.nodeType];
    },
    showText() {
      // if (this.nodeConfig.nodeType == 0) {
      //   return preload.setPromoterStr(this.nodeConfig) || '';
      // } else if (this.nodeConfig.nodeType == 1) {
      //   return preload.setApproverStr(this.nodeConfig);
      // }
      // return preload.copyerStr(this.nodeConfig);
      switch (this.nodeConfig.nodeType) {
        case 0: // 发起人
          return preload.setPromoterStr(this.nodeConfig);
        case 1: // 审核人
          return preload.setApproverStr(this.nodeConfig);
        case 2: // 抄送人
          return preload.copyerStr(this.nodeConfig);
        case 3: // 办理人
          return preload.setTransactorStr(this.nodeConfig);
        default:
          // 其他
          return '';
      }
    },
    bgColor() {
      return ['87, 106, 149', '255, 148, 62', '50, 150, 250', '125, 7, 242'][
        this.nodeConfig.nodeType
      ];
    }
  },
  watch: {
    promoterConfig1(data) {
      if (data.flag && data.id === this._uid) {
        this.$emit('update:nodeConfig', data.value);
      }
    },
    approverConfig1(data) {
      if (data.flag && data.id === this._uid) {
        this.$emit('update:nodeConfig', data.value);
      }
    },
    copyerConfig1(data) {
      if (data.flag && data.id === this._uid) {
        this.$emit('update:nodeConfig', data.value);
      }
    },
    conditionsConfig1(data) {
      if (data.flag && data.id === this._uid) {
        this.$emit('update:nodeConfig', data.value);
      }
    },
    transactorConfig1(data) {
      if (data.flag && data.id === this._uid) {
        this.$emit('update:nodeConfig', data.value);
      }
    }
  },
  methods: {
    ...mapMutations('workflow', [
      'setPromoter',
      'setApprover',
      'setCopyer',
      'setTransactor',
      'setCondition',
      'setPromoterConfig',
      'setApproverConfig',
      'setCopyerConfig',
      'setTransactorConfig',
      'setConditionsConfig'
    ]),
    clickEvent(index) {
      if (index || index === 0) {
        this.$set(this.isInputList, index, true);
      } else {
        this.isInput = true;
      }
    },
    blurEvent(index) {
      if (index || index === 0) {
        this.$set(this.isInputList, index, false);
        this.nodeConfig.branchList[index].nodeName =
          this.nodeConfig.branchList[index].nodeName || '条件';
      } else {
        this.isInput = false;
        this.nodeConfig.nodeName = this.nodeConfig.nodeName || this.defaultText;
      }
    },
    delNode() {
      this.$emit('update:nodeConfig', this.nodeConfig.child);
    },
    addTerm() {
      const len = this.nodeConfig.branchList.length; // 字段长度
      const lastBranchItem = this.nodeConfig.branchList[len - 1]; // 最后一个条件保持不变
      const newBranchItem = {
        nodeName: `条件${len}`,
        nodeType: 4,
        priorityLevel: len,
        conditionList: [],
        child: null
      };
      const newLastBranchItem = {
        ...lastBranchItem,
        priorityLevel: len + 1
      };
      this.nodeConfig.branchList.splice(
        len - 1,
        1,
        newBranchItem,
        newLastBranchItem
      );
      this.resetConditionNodesErr();
      this.$emit('update:nodeConfig', this.nodeConfig);
    },
    delTerm(index) {
      this.nodeConfig.branchList.splice(index, 1);
      this.nodeConfig.branchList.forEach((item, index) => {
        item.priorityLevel = index + 1;
      });
      this.resetConditionNodesErr();
      this.$emit('update:nodeConfig', this.nodeConfig);
      if (this.nodeConfig.branchList.length == 1) {
        if (this.nodeConfig.child) {
          if (this.nodeConfig.branchList[0].child) {
            this.reData(
              this.nodeConfig.branchList[0].child,
              this.nodeConfig.child
            );
          } else {
            this.nodeConfig.branchList[0].child = this.nodeConfig.child;
          }
        }
        this.$emit('update:nodeConfig', this.nodeConfig.branchList[0].child);
      }
    },
    reData(data, addData) {
      if (!data.child) {
        data.child = addData;
      } else {
        this.reData(data.child, addData);
      }
    },
    setPerson(priorityLevel) {
      const { nodeType } = this.nodeConfig;
      if (nodeType == 0) {
        this.setPromoter(true);
        this.setPromoterConfig({
          value: {
            ...JSON.parse(JSON.stringify(this.nodeConfig)),
            ...{
              userType: this.nodeConfig.userType ? this.nodeConfig.userType : 1
            }
          },
          flag: false,
          id: this._uid
        });
      } else if (nodeType == 1) {
        this.setApprover(true);
        this.setApproverConfig({
          value: {
            ...JSON.parse(JSON.stringify(this.nodeConfig)),
            ...{
              auditType: this.nodeConfig.auditType
                ? this.nodeConfig.auditType
                : 1
            }
          },
          flag: false,
          id: this._uid
        });
      } else if (nodeType == 2) {
        this.setCopyer(true);
        this.setCopyerConfig({
          value: {
            ...JSON.parse(JSON.stringify(this.nodeConfig)),
            userType: this.nodeConfig.userType || 1
          },
          flag: false,
          id: this._uid
        });
      } else if (nodeType == 3) {
        // type == 3 的时候 暂时 使用 审批人的 transactorDrawer
        this.setTransactor(true);
        this.setTransactorConfig({
          value: {
            ...JSON.parse(JSON.stringify(this.nodeConfig)),
            ...{
              settype: this.nodeConfig.settype ? this.nodeConfig.settype : 1
            }
          },
          flag: false,
          id: this._uid
        });
      } else {
        if (this.nodeConfig.branchList.length == priorityLevel) {
          return console.log('其他条件不能设置条件');
        }
        this.setCondition(true);
        this.setConditionsConfig({
          value: JSON.parse(JSON.stringify(this.nodeConfig)),
          priorityLevel,
          flag: false,
          id: this._uid
        });
      }
    },
    setCopyCondition(item) {
      // 复制份
      const copyCondition = _.cloneDeep(item);
      const len = this.nodeConfig.branchList.length;
      copyCondition.priorityLevel = len;
      this.nodeConfig.branchList.splice(len - 1, 0, copyCondition);
      // 设置默认值 将最后一个默认值设置为最新长度，把加入的
      const newLen = this.nodeConfig.branchList.length;
      this.nodeConfig.branchList[newLen - 1].priorityLevel;
      this.$emit('update:nodeConfig', this.nodeConfig);
    },
    arrTransfer(index, type = 1) {
      // 向左-1,向右1
      this.nodeConfig.branchList[index] = this.nodeConfig.branchList.splice(
        index + type,
        1,
        this.nodeConfig.branchList[index]
      )[0];
      this.nodeConfig.branchList.forEach((item, index) => {
        item.priorityLevel = index + 1;
      });
      this.$emit('update:nodeConfig', this.nodeConfig);
    },
    resetConditionNodesErr() {
      for (let i = 0; i < this.nodeConfig.branchList.length; i++) {
        this.nodeConfig.branchList[i].error =
          preload.conditionStr(this.nodeConfig, i) == '请设置条件' &&
          i != this.nodeConfig.branchList.length - 1;
      }
    }
  }
};
</script>
<style>
.error_tip {
  position: absolute;
  top: 0px;
  right: 0px;
  transform: translate(150%, 0px);
  font-size: 24px;
}

.promoter_person .el-dialog__body {
  padding: 10px 20px 14px 20px;
}

.selected_list {
  margin-bottom: 20px;
  line-height: 30px;
}

.selected_list span {
  margin-right: 10px;
  padding: 3px 6px 3px 9px;
  line-height: 12px;
  white-space: nowrap;
  border-radius: 2px;
  border: 1px solid rgba(220, 220, 220, 1);
}

.selected_list img {
  margin-left: 5px;
  width: 7px;
  height: 7px;
  cursor: pointer;
}
.priority-copy {
  display: none;
  position: absolute;
  right: 10px;
  top: -8px;
  color: rgba(25, 31, 37, 0.56);
}
</style>
